import React from 'react';

const isVideoPreview = (url) => {
  if (!url) return false;
  const urlLower = url.toLowerCase();
  return urlLower.includes('mime_type=video') || /\.(mp4|mov|webm)(\?|#|$)/i.test(urlLower);
};

function PresetPreviewMedia({ src, title, index }) {
  const label = `${title} preview ${index + 1}`;

  if (isVideoPreview(src)) {
    return (
      <video
        src={src}
        aria-label={label}
        muted
        loop
        playsInline
        autoPlay
        preload="metadata"
        onError={(e) => {
          e.target.style.display = 'none';
        }}
        onLoadedData={(e) => {
          e.target.play().catch(() => {});
        }}
      />
    );
  }

  return (
    <img
      src={src}
      alt={label}
      loading="lazy"
      onError={(e) => {
        e.target.style.display = 'none';
      }}
    />
  );
}

export default PresetPreviewMedia;
